import { render, staticRenderFns } from "./MessagePopup.vue?vue&type=template&id=59ab2eb1&scoped=true"
import script from "./MessagePopup.vue?vue&type=script&lang=js"
export * from "./MessagePopup.vue?vue&type=script&lang=js"
import style0 from "./MessagePopup.vue?vue&type=style&index=0&id=59ab2eb1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ab2eb1",
  null
  
)

export default component.exports